import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { InputSearch, NormalButton } from "component/common";
import { Tab } from "component/common";
import { history } from "helpers";
import { getCommonApi } from "redux/actions/common";

export class ReportsMenuClass extends Component {
  state = {
    Reports: [],
    projectList: [],
    statusOption: [],
    filterdata: [],
    is_loading: true,
    isMounted: true,
    search: "",
    searchString: "",
    seachdata: [],
    active: false,
    currentValue: 0,

    navLinks: [
      {
        to: this.props.location.pathname,
        label: "Activities",
        id: "Activities",
      },
      { to: this.props.location.pathname, label: "Quotation", id: "Quotation" },
      { to: this.props.location.pathname, label: "Purchase Order", id: "PO" },
    ],
    selectedMenu: "Activities",
  };
  handleReports() {
    let { Reports } = this.state;
    this.props.getCommonApi(`reportmaster/?page=1&limit=20`).then((res) => {
      console.log(res.data, "result");
      this.setState({
        Reports: res.data.dataList,
      });
    });
  }
  updateState = (data) => {
    if (this.state.isMounted) this.setState(data);
  };
  componentDidMount() {
    this.handleReports();
  }
  handleChange(e) {
    let { search, searchString, Reports } = this.state;

    this.setState({
      search: e.target.value,
    });
    this.props
      .getCommonApi(`reportmaster/?page=1&limit=20&search=${e.target.value}`)
      .then((key) => {
        let { status, data } = key;
        // this.setState({ search: Reports.name });
        if (status === 200) {
          {
            console.log(
              data.dataList.map((item) => {
                return item.name;
              }),
              "dateee"
            );
          }
          let test = data.dataList;
          this.setState({
            Reports: test,
          });
        }
      });
  }

  render() {
    let { Reports } = this.state;
    return (
      <div className="col-12">
        <div className="container-fluid bg-white px-md-5 my-3">
          <div className="py-5 px-md-5">
            <p className="fs-16">
              <span className="font-weight-bold px-1 ">HOME</span>/REPORTS
            </p>
            <h1 className="my-4 reports-heading">Reports</h1>
            <p className="font-weight-normal fs-16">
              See full list of your reports here
            </p>
            <div className="row">
              <div>
                <Tab />
              </div>
            </div>
            <div className="row my-3">
              <div className="col-md-8 font-weight-bold">
                <p className="fs-18 fw-400"> Uncategorized Reports</p>
                {}

                {/* <InputSearch
                  className=""
                  placeholder="Search product"
                  onChange={this.handlesearch}
                  name="searchText"
                /> */}
              </div>

              <div className="col-md-4">
                {" "}
                <InputSearch
                  name="search"
                  value={this.state.search}
                  onChange={(e) => {
                    this.handleChange(e);
                  }}
                  placeholder="Search "
                />{" "}
              </div>
            </div>
            <div className="row">
              {console.log(Reports, "Reports")}
              {Reports.map((item, index) => {
                return (
                  <>
                    {/* <div key={index}>{item.name}</div> */}
                    <div className="col-lg-6 col-12" key={index}>
                      <div className="card">
                        <div className="card-body row">
                          <div className="col-md-2">
                            <img
                              alt="report"
                              className="w-75"
                              src={item.image}
                            />
                          </div>
                          <div className="col-md-6 col-12 ">
                            <p className="fw-500 text-blue report-heading fs-18">
                              {" "}
                              {item.name}
                            </p>
                            <p className="report-heading fs-16 my-2">
                              {item.description}
                            </p>
                          </div>
                          <div className="col-md-4 col-12 mt-2">
                            <NormalButton
                              mainbg={true}
                              label={"View Report"}
                              onClick={() => history.push(item.url)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCommonApi }, dispatch);
};

export const ReportsMenu = withTranslation()(
  connect(null, mapDispatchToProps)(ReportsMenuClass)
);
